import React, { useState } from "react";
import styled from "styled-components";
import RenderIf from "../renderIf";

const ViewTable = ({
  columns,
  data,
  itemsPerPage = 5,
  pagination = true,
}: any) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the index range for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = pagination
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : data;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <CustomeTable className="w-100">
        <thead>
          <tr className="border-bottom">
            {columns.map((column: any) => (
              <th
                className="sm-text text-secondary  p-2 m-1"
                key={column.accessor}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.map((row: any) => (
            <tr key={row.id} className="border-bottom">
              {columns.map((column: any) => (
                <td key={column.accessor} className="p-2 m-1 sm-text">
                  {column.cell
                    ? // If a custom cell component is provided, use it
                      column.cell(row)
                    : // Otherwise, display the default cell content
                      row[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </CustomeTable>
      <RenderIf isShow={pagination}>
        <PaginationBlock className="my-2">
          <button
            className={`arrow-btn  rounded me-2 bg-white`}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            {`<`}
          </button>
          <button
            className={`arrow-btn  rounded me-2  bg-white`}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            {`>`}
          </button>
          <span className="m-1">
            Page{" "}
            <b>
              {currentPage} of {totalPages}
            </b>
          </span>
        </PaginationBlock>
      </RenderIf>
    </>
  );
};

export default ViewTable;

const CustomeTable = styled.table`
  thead {
    width: 100%;
  }
  tr {
  }
  th {
  }
  tbody {
  }
  td {
  }
`;

const PaginationBlock = styled.div`
  .arrow-btn {
    border: 0.5px solid rgb(119, 119, 119);
    width: 35px;
    align-items: center;
    justify-content: center;
    height: 40px;
  }
`;
